import { observer } from 'mobx-react-lite';
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';

const ForParents: FC = () => {

    const navigate = useNavigate()

    return (
        <div className='row pt-5 m-3'>
            <div className='col-md-6' onClick={() => navigate('/parents/recs/')} style={{ cursor: 'pointer' }}>
                <img src="/images/recs.jpg" alt="Рекомендации" />
            </div>
            <div className='col-md-6' onClick={() => navigate('/parents/lits/')} style={{ cursor: 'pointer' }}>
                <img src="/images/liters.jpeg" alt="Литература" />
            </div>
        </div>
    );
};

export default observer(ForParents);